/* eslint-disable react-hooks/exhaustive-deps */
import './BannerTab.scss'
import SelectLocation from '../ui/SelectLocation'
import DatePickerIcon from '../ui/DatePickerIcon'
import * as React from 'react'
import { useEffect, useRef, useState } from 'react'
import { IAbroad, IFloorList, ISearchFloor, ReservationMeta, RoutingType } from '../../types/FloorType'
import FloorService from '../../service/FloorService'
import { GroupSelect } from '../../types/BaseType'
import { CalendarChangeParams } from 'primereact/calendar'
import { PlanTabs } from '../../types/PlanTabs'
import DateUtil from '../../utils/DateUtil'
import { IEmployeeSummary } from '../../types/Employee'
import { IMostUsedReservationResponse } from '../../types/Reservation'
import useDidMountEffect from '../../utils/useDidMountEffect'
import AuthUtil from '../../utils/AuthUtil'
import { Checkbox } from 'primereact/checkbox'
import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button'
import warningIcon from './../../assets/icons/warning-icon-blue.svg'
import EmployeeService from '../../service/EmployeeService'
import HomeOfficeTypeSelection from '../ui/HomeOfficeTypeSelection'
import { useTranslation } from 'react-i18next'

const BannerTab = (props: {
  form: ReservationMeta | undefined
  onChangeForm: (meta: ReservationMeta) => void
  name: PlanTabs
  employee: IEmployeeSummary | undefined
  isReservationSearch: boolean
  selectedLocation?: IFloorList | IMostUsedReservationResponse
  selectedStartDate?: Date | Date[]
  selectedEndDate?: Date | Date[]
  selectStyle?: string
  setDisabled: any
  dateStyle?: string
  selectedType: any
  types: any
  setSelectedType: any
  isAbroad: IAbroad
  setIsAbroad: any
}) => {
  const [selectedLocation, setSelectedLocation] = useState<
    IFloorList | IMostUsedReservationResponse | string | undefined
  >(props.selectedLocation)
  const { t } = useTranslation()
  const [floorSearchList, setFloorSearchList] = useState<GroupSelect[]>([])
  const [defaultStartDate, setDefaultStartDate] = useState<Date | Date[] | undefined>(props.selectedStartDate)
  const [defaultEndDate, setDefaultEndDate] = useState<Date | Date[] | undefined>(props.selectedEndDate)
  const [minStartDate, setMinStartDate] = useState<Date | undefined>()
  const [maxStartDate, setMaxStartDate] = useState<Date | undefined>()
  const [minEndDate, setMinEndDate] = useState<Date | undefined>()
  const [maxEndDate, setMaxEndDate] = useState<Date | undefined>()
  const [fullness, setFullness] = useState<boolean>(true)
  const [searchShow, setSearchShow] = useState<boolean>(false)
  const [showDedicatedTablePopup, setShowDedicatedTablePopup] = useState<boolean>()
  const [showAgain, setshowAgain] = useState<boolean>(false)
  const [filter, setFilter] = useState<ISearchFloor>()

  const isFirstRender = useRef(true)
  const employee = AuthUtil.getEmployeeSummary() as IEmployeeSummary

  useEffect(() => {
    let employeeSummary = AuthUtil.getEmployeeSummary()
    if (employeeSummary != null) {
      setShowDedicatedTablePopup(employeeSummary.showDedicatedTablePopup)
    }

    var dropdownButton = document.getElementsByClassName(
      'p-button p-component p-autocomplete-dropdown p-button-icon-only'
    )
    if (dropdownButton !== undefined && dropdownButton.length > 0) {
      dropdownButton[0].classList.add('d-none')
    }
    let date = DateUtil.getNearestWorkDay()
    setDefaultStartDate(date)
    setDedicatedFloor()
  }, [])

  useEffect(() => {
    let date = new Date()
    let futureDate = new Date()
    let pastDate = new Date()

    let futureDayCount = Number(employee.futureOrientedDayCount)
    let pastDayCount = Number(employee.pastOrientedDayCount)

    futureDate.setDate(futureDate.getDate() + futureDayCount)
    setMaxStartDate(futureDate)

    pastDate.setDate(pastDate.getDate() - pastDayCount)
    setMinStartDate(pastDate)

    if (pastDayCount !== 0) {
      let dayOfWeek = date.getDay()
      if (dayOfWeek === 6) {
        date.setDate(date.getDate() + 2)
      } else if (dayOfWeek === 0) {
        date.setDate(date.getDate() + 1)
      }
      setDefaultStartDate(date)
    } else {
      date.setDate(date.getDate() + 1)
      let dayOfWeek = date.getDay()
      if (dayOfWeek === 6) {
        date.setDate(date.getDate() + 2)
      } else if (dayOfWeek === 0) {
        date.setDate(date.getDate() + 1)
      }
      setDefaultStartDate(date)
      setMinStartDate(date)
    }
  }, [])

  useEffect(() => {
    if (props.selectedEndDate) setDefaultEndDate(props.selectedEndDate)
    else if (props.selectedStartDate) setDefaultEndDate(props.selectedStartDate)
    else setDefaultEndDate(new Date())
    let validDaysCount = Number(employee ? employee.pastOrientedDayCount : 0)
    if (validDaysCount === 0) {
      setDefaultEndDate(defaultStartDate)
    }
  }, [])

  useEffect(() => {
    if (props.isReservationSearch && isFirstRender.current && props.selectedStartDate && props.selectedEndDate) {
      isFirstRender.current = false
      setDefaultStartDate(props.selectedStartDate)
      setMinEndDate(props.selectedStartDate as Date)
      let date = new Date()
      let forwardDaysReach = employee ? employee.futureOrientedDayCount : 0
      date.setDate(date.getDate() + forwardDaysReach)
      setMaxEndDate(date)
      if (isEndDateValid(defaultEndDate as Date, defaultStartDate as Date)) setDefaultEndDate(defaultStartDate)
      return
    }
    setMinEndDate(new Date(defaultStartDate as Date))
    let date = new Date()
    let forwardDaysReach = employee ? employee.futureOrientedDayCount : 0
    date.setDate(date.getDate() + forwardDaysReach)
    setMaxEndDate(date)
    changeFormValues(defaultStartDate as Date, new Date(defaultEndDate as Date) as Date, selectedLocation as IFloorList)
    if (isEndDateValid(defaultEndDate as Date, defaultStartDate as Date)) {
      setDefaultEndDate(defaultStartDate)
      changeFormValues(defaultStartDate as Date, defaultStartDate as Date, selectedLocation as IFloorList)
    }
  }, [defaultStartDate])

  const isEndDateValid = (startDate: Date, endDate: Date) => {
    return endDate > startDate
  }

  const onSelectedStartDateChange = (e: CalendarChangeParams) => {
    setDefaultStartDate(e.value)
    changeFormValues(e.value as Date, defaultEndDate as Date, selectedLocation as IFloorList)
  }

  const onSelectedEndDateChange = (e: CalendarChangeParams) => {
    setDefaultEndDate(e.value)
    changeFormValues(defaultStartDate as Date, e.value as Date, selectedLocation as IFloorList)
  }

  function changeFormValues(startDate: Date, endDate: Date, selectedLoc: IFloorList) {
    props.onChangeForm({
      isNew: true,
      startDate: startDate && new Date(startDate.setHours(0, 0, 0, 0)),
      endDate: endDate && new Date(endDate.setHours(0, 0, 0, 0)),
      selectedFloor: selectedLoc,
      planTab: props.name,
      routingType: RoutingType.HOME_PAGE,
      isAbroad: props.isAbroad,
    })
  }

  function relocateAutoCompletePanel(cnt: number) {
    let dropdown1Elm = document.getElementsByClassName('dropdown1')[0]
    var rectDropdown1Elm = dropdown1Elm.getBoundingClientRect()
    var autoCompletePanelElm = document.getElementsByClassName('p-autocomplete-panel')[0]
    var autoCompleteInput = document.getElementsByClassName('p-inputtext p-component p-autocomplete-input')[0]
    var rectAutoCompleteInput = autoCompleteInput.getBoundingClientRect()
    if (autoCompletePanelElm !== undefined) {
      let acpOldStyle = autoCompletePanelElm.getAttribute('style') as string
      let acpNewStyle = acpOldStyle.concat(`left: ${rectDropdown1Elm.x + window.scrollX}px!important`)
      acpNewStyle = acpNewStyle.concat(
        `;top: ${rectDropdown1Elm.y + rectAutoCompleteInput.height + window.scrollY}px!important`
      )
      autoCompletePanelElm.setAttribute('style', acpNewStyle)
    } else {
      if (cnt < 10) relocateAutoCompletePanel(++cnt)
    }
  }

  const searchLocation = (event: { query: string }) => {
    let query = event.query === undefined ? '' : event.query
    if (event.query === '') {
      var text = document.getElementsByClassName('p-inputtext p-component p-filled p-autocomplete-input')
      if (text.length > 0) {
        // @ts-ignore
        query = text[0].value
      }
    }
    setFullness(
      DateUtil.formatDateToString(defaultStartDate as Date) === DateUtil.formatDateToString(defaultEndDate as Date)
    )
    let dateStr = DateUtil.formatDateToString(defaultStartDate as Date)
    let myFirm: boolean = props.name === PlanTabs.OFFICE
    let searchQuery: ISearchFloor | any =
      props.name === PlanTabs.COMMON
        ? {
            SearchText: query,
            MyFirm: myFirm,
            OccupancyDate: dateStr,
            CityIdList: filter?.cityIdList,
            FirmIdList: filter?.firmIdList,
            LocationPropIdList: filter?.locationPropIdList,
            BlockPropIdList: filter?.blockPropIdList,
            FloorPropIdList: filter?.floorPropIdList,
            IsAbroad: props.isAbroad.isAbroad,
            CampusServicesList: filter?.campusServicesList,
            Rate: filter?.rate,
          }
        : {
            SearchText: query,
            MyFirm: myFirm,
            OccupancyDate: dateStr,
            CityIdList: filter?.cityIdList,
            FirmIdList: filter?.firmIdList,
            LocationPropIdList: filter?.locationPropIdList,
            BlockPropIdList: filter?.blockPropIdList,
            FloorPropIdList: filter?.floorPropIdList,
          }

    FloorService.searchFloor(searchQuery)
      .then((response) => {
        let groups: GroupSelect[] = []
        let group: GroupSelect = new GroupSelect()
        group.label = ''
        response.data.forEach((res) => {
          res._fullLocation = [res?.locationName, res?.districtName, res?.blockName, res?.name]
            .filter((val) => val)
            .join(', ')
          res._floorName = res.name
          res._id = res.id
          group.items.push(res)
        })
        groups.push(group)
        setFloorSearchList(groups)
      })
      .then(() => relocateAutoCompletePanel(0))
      .catch((e) => {
        console.log(e)
      })
  }

  const onLocationChange = (e: { value: any }) => {
    setSelectedLocation(e.value)
    props.onChangeForm({
      isNew: true,
      startDate: DateUtil.isWeekend(defaultStartDate as Date)
        ? DateUtil.getNearestWorkDay()
        : (defaultStartDate as Date),
      endDate: DateUtil.isWeekend(defaultEndDate as Date) ? DateUtil.getNearestWorkDay() : (defaultEndDate as Date),
      selectedFloor: e.value as IFloorList,
      planTab: props.name,
      routingType: RoutingType.HOME_PAGE,
      isAbroad: props.isAbroad,
    })
  }

  const setDedicatedFloor = () => {
    if (props.name === PlanTabs.OFFICE) {
      FloorService.getMyDedicatedFloor(DateUtil.formatDateToString(new Date())).then((response) => {
        response.data._id = response.data.id
        response.data._floorName = response.data.name
        response.data._fullLocation = [
          response.data?.locationName,
          response.data?.districtName,
          response.data?.blockName,
          response.data?.name,
        ]
          .filter((val) => val)
          .join(', ')
        if (response.data.id !== 0 && response.data?.locationName !== null && selectedLocation === undefined) {
          onLocationChange({ value: response.data })
        }
      })
    }
  }

  const onLocationSelect = (e: { value: any }) => {
    setSelectedLocation(e.value)
  }

  const filterList = (
    city: number[],
    firm: number[],
    location: number[],
    block: number[],
    floor: number[],
    campus: number[],
    rate: number[]
  ) => {
    setFilter((prevState) => ({
      ...prevState,
      CityIdList: city,
      FirmIdList: firm,
      LocationPropIdList: location,
      BlockPropIdList: block,
      FloorPropIdList: floor,
      CampusServicesList: campus,
      Rate: rate,
    }))
  }

  useDidMountEffect(() => {
    searchLocation({ query: '' })
  }, [filter])

  const onClickLocation = () => {
    var button = document.getElementsByClassName('p-button p-component p-autocomplete-dropdown p-button-icon-only')
    if (button !== undefined && button.length > 0 && !searchShow) {
      // @ts-ignore
      button[0].click()
    }
  }

  const onClearLocation = () => {
    setTimeout(() => {
      var button = document.getElementsByClassName('p-button p-component p-autocomplete-dropdown p-button-icon-only')
      if (button !== undefined && button.length > 0) {
        // @ts-ignore
        button[0].click()
      }
    }, 300)
  }

  const onShowLocation = () => {
    setSearchShow(true)
  }
  const onHideLocation = () => {
    setSearchShow(false)
  }

  const dedicatedClosed = () => {
    if (showAgain) {
      let employeeSummary = AuthUtil.getEmployeeSummary()
      if (employeeSummary != null) {
        employeeSummary.showDedicatedTablePopup = false
        localStorage.setItem('employee', JSON.stringify(employeeSummary))
      }
      EmployeeService.updateDedicatedShowInfo()
        .then((response) => {
          setShowDedicatedTablePopup(false)
        })
        .catch((e) => {
          console.log(e)
        })
    } else {
      setShowDedicatedTablePopup(false)
    }
  }
  const clearInput = () => {
    setSelectedLocation(undefined)
    props.setDisabled(true)
  }

  return (
    <div className="row mb-4">
      {props.name === PlanTabs.AWAY ? (
        props.types.length > 0 ? (
          <div className={props.selectStyle}>
            <HomeOfficeTypeSelection
              selectedType={props.selectedType}
              setSelectedType={props.setSelectedType}
              types={props.types}
            />
          </div>
        ) : null
      ) : (
        <>
          <div className={props.name === PlanTabs.COMMON ? 'col-lg-8 col-12 mb-2' : props.selectStyle}>
            <SelectLocation
              name={props.name}
              isAbroad={props.isAbroad}
              placeholder={t('input-texts.search-office-placeholder')}
              optionLabel="_fullLocation"
              onLocationChange={onLocationChange}
              onLocationSelect={onLocationSelect}
              selectedLocation={selectedLocation}
              onCompleteMethod={searchLocation}
              floorSearchList={floorSearchList}
              filterList={filterList}
              clearInput={clearInput}
              fullness={fullness}
              onClick={(e) => onClickLocation()}
              onClear={() => onClearLocation()}
              onShow={() => onShowLocation()}
              onFilterHide={() => onClickLocation()}
              onHide={() => onHideLocation()}
              myFirm={props.name === PlanTabs.OFFICE}
              setIsAbroad={props.setIsAbroad}
              setSelectedLocation={setSelectedLocation}
            />

            {((props.name === PlanTabs.OFFICE && !props.isReservationSearch) ||
              props.selectedLocation?.hasDedicatedTable) && (
              <Dialog
                contentClassName={'bottom-border-radius'}
                visible={showDedicatedTablePopup}
                style={{ width: '35vw' }}
                onHide={() => setShowDedicatedTablePopup(false)}>
                <div className={'p-4'}>
                  <div className="text-center mb-4">
                    <img src={warningIcon} alt="icon" />
                  </div>
                  <div className="mb-2 text-center fw-bold">{t('overlaypanel-texts.info-header')}</div>
                  <div className="mb-4 text-center">{t('bannertab.text')}</div>
                  <div className={'p-field-checkbox mb-4'}>
                    <Checkbox inputId="cb1" checked={showAgain} onChange={(e) => setshowAgain(e.checked)}></Checkbox>
                    <label htmlFor="cb1" className="p-checkbox-label ms-1">
                      {t('bannertab.dont-show')}
                    </label>
                  </div>
                  <div>
                    <Button
                      label={t('buttons.ok')}
                      onClick={() => dedicatedClosed()}
                      className={'button-blue w-100'}></Button>
                  </div>
                </div>
              </Dialog>
            )}
          </div>
        </>
      )}
      <div className={props.name === PlanTabs.COMMON ? 'col-lg-4 col-12' : props.dateStyle}>
        <div className="row">
          <div className="col-6 mb-2">
            <DatePickerIcon
              idName="search-start-date"
              defaultDate={defaultStartDate}
              minDate={minStartDate}
              maxDate={maxStartDate}
              onSelectedDateChange={onSelectedStartDateChange}
              label={t('input-texts.first-date-of-plan')}
            />
          </div>
          <div className="col-6 mb-2">
            <DatePickerIcon
              idName="search-end-date"
              defaultDate={defaultEndDate}
              minDate={minEndDate}
              maxDate={maxEndDate}
              onSelectedDateChange={onSelectedEndDateChange}
              label={t('input-texts.last-date-of-plan')}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
export default BannerTab
